import SignUpComponent from "../MVPComponents/auth/SignUpComponent";

const SignUp = () => {
  return <SignUpComponent />;
};

export default SignUp;
